import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import VueClipboard from "vue-clipboard2";

require("@/assets/styles/resets.css");
require("@/assets/styles/base.css");

Vue.use(VueClipboard);

Vue.prototype.$assets =
  "https://s3.amazonaws.com/s3.pilates.com/web-affiliates/";
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
